import { render, staticRenderFns } from "./YourPromotion.vue?vue&type=template&id=ce3638d8&scoped=true"
import script from "./YourPromotion.vue?vue&type=script&lang=js"
export * from "./YourPromotion.vue?vue&type=script&lang=js"
import style0 from "./YourPromotion.vue?vue&type=style&index=0&id=ce3638d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3638d8",
  null
  
)

export default component.exports